import React from "react";
import SwitchButton from "../../../../../../../components/switchButton";
import { Spinner } from "../../../../../../../components/loading";
import { convertRialToToman } from "../../../../../../../lib/convertRialToToman";

export const Wallet = props => {
  return (
    <React.Fragment>
      <span className="text-for-credit-use">
        استفاده از امتیاز‌های من
        <span className="credit-amount">
          ({convertRialToToman(props.wallet_amount)})
          <span className="credit-currency"> تومان</span>
        </span>
      </span>
      {!props.useWalletLoading && (
        <SwitchButton
          input={{
            value: props.status,
            onChange: () => props.onChange(!props.status)
          }}
        />
      )}
      {props.useWalletLoading && <Spinner />}
    </React.Fragment>
  );
};
